import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { updateNavbarHeading } from "../../../constants/layout/store/filterSlice";
import { API_URL } from "../../../constants";
import { GetServiceCaller } from "../../../services/serviceCaller";
import { Table } from "react-bootstrap";
import Select from "react-select";
import moment from "moment";
import { FaSpinner } from "react-icons/fa";

const MyComponent = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(updateNavbarHeading("My Components"));
  }, []);

  const [myComponent, setMyComponent] = useState([]);
  const [scaleList, setScaleList] = useState([]);
  const [selectedMonth, setSelectedMonth] = useState(null);
  const [employeeName, setEmployeeName] = useState("");
  const [employeeDesignation, setEmployeeDesignation] = useState("");
  const [joinDate, setJoinDate] = useState("");

  const handleGetDataClick = () => {
    if (selectedMonth) {
      setMyComponent([]); // Ensure list is blank
      fetchMyComponent(selectedMonth);
    } else {
      alert("Please select a month first!");
    }
  };

  const [apiStatus, setApiStatus] = useState("");

  const fetchMyComponent = async (month) => {
    setApiStatus(undefined);
    try {
      const response = await GetServiceCaller(
        `${API_URL}payroll/my-component?P_AsOnDate=${month || 1}`
      );
      if (response?.status === 200) {
        setApiStatus(response?.status);
        const data = response?.data?.data?.componentDetails;
        setMyComponent(data || []);
        setApiStatus(200);

        //scale List
        const ScaleOptList = Object.entries(
          response?.data?.data?.scale || {}
        ).map(([key, value]) => ({
          value: key,
          label: value,
        }));

        setScaleList(ScaleOptList);
        setSelectedMonth(
          (prevSelected) => prevSelected ?? ScaleOptList[0]?.value
        );

        // Employee Name
        const name = response?.data?.data?.name;
        setEmployeeName(name);

        // Designation
        const designation = response?.data?.data?.designation;
        setEmployeeDesignation(designation);

        // joining Date
        const doj = response?.data?.data?.doj?.JoiningDate;
        const formattedDate = doj ? moment(doj).format("MMMM D, YYYY") : "";
        setJoinDate(formattedDate);
      }
    } catch (error) {
      setApiStatus(400);
      console.error("Error fetching My Components", error);
    }
  };

  useEffect(() => {
    fetchMyComponent();
  }, []);

  const allowedPayrolls = [
    "Basic",
    "HRA",
    "Spl Allow",
    "Other Allowance",
    "Professional Development Allowance",
    "Conv Allow",
    "Leave Travel Allowance",
    "NPS", 
    "Sales Incentive",
    "Gross Salary",
    "Leave Encashment",
    "Annual Performance Bonus",
    "CCA",
    "Provident Fund",
    "Gratuity",
    "EOS",
    "Mediclaim Insurance",
  ];
  const payrollLabelMap = {
    2: {
      "Professional Development Allowance": "Spl Allow",
    },
  };
  const filteredData = myComponent?.filter((item) =>
    allowedPayrolls.includes(item.Payroll)
  );
  let fromDate;
  filteredData.forEach((item) => {
    // console.log(item.FromDate);
    fromDate = item.FromDate
      ? moment(item.FromDate).format("MMMM D, YYYY")
      : "";
  });

  const totalAnnualAmount = filteredData?.reduce(
    (sum, item) =>
      item.Payroll !== "Gross Salary" ? sum + parseFloat(item.AnnualAmount || 0) : sum,
    0
  );


  console.log("filteredData", filteredData);


  return (
    <>
      <div className="container-fluid" id="skill_section">
        <div className="container-fluid" id="myComponent">
          <div className="row">
            <div className="d-flex">
              <div>
                <label htmlFor="Code" className="form-label">
                  Scale
                </label>
                <Select
                  options={scaleList}
                  value={scaleList.find((item) => item.value === selectedMonth)}
                  onChange={(selectedOption) => {
                    setSelectedMonth(selectedOption.value);
                    setMyComponent([]); // 1. Clear the list immediately
                    setApiStatus("");   // 2. Reset status so it doesn't show "No Data Found"
                  }}
                  // // onChange={(selectedOption) =>
                  // //   setSelectedMonth(selectedOption.value)
                  // }
                />
              </div>
              <div>
                <button className="custom-btn" style={{ marginTop: "35px", marginLeft: "10px" }} onClick={handleGetDataClick}>
                  Get Data
                </button>
              </div>
            </div>
          </div>

          {apiStatus === 200 && myComponent.length !== 0 ? (
            <div className="container-fluid" id="component_Annexure">
              <div className="text-center">
                <h4>ANNEXURE A</h4>
                <h5>
                  <strong>
                    {employeeName} - {employeeDesignation}
                  </strong>{" "}
                  (Effective From {fromDate})
                </h5>
              </div>
              <div className="table-responsive">
                <Table striped bordered hover>
                  <thead id="thcolor" className="text-center">
                    <tr>
                      <th>EARNINGS</th>
                      <th>PER MONTH</th>
                      <th>Annual Amount</th>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredData?.map((item, index) => (
                      <tr
                        key={index}
                        style={
                          item.Payroll === "Gross Salary"
                            ? { fontWeight: "bold" }
                            : {}
                        }
                      >
                        {/* <td>{item.Payroll}</td> */}
                        <td>
                        {payrollLabelMap[selectedMonth]?.[item.Payroll] || item.Payroll}
                      </td>
                        <td className="text-end">
                          {![
                            "Leave Encashment",
                            "Annual Performance Bonus",
                            "Provident Fund",
                            "Gratuity",
                            "Mediclaim Insurance",
                            "EOS"
                          ].includes(item.Payroll)
                            ? parseFloat(item.Amount)?.toLocaleString("en-IN", {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })
                            : ""}
                        </td>
                        <td className="text-end">
                          {parseFloat(item.AnnualAmount)?.toLocaleString(
                            "en-IN",
                            {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            }
                          )}
                        </td>
                      </tr>
                    ))}

                    <tr style={{ fontWeight: "bold" }}>
                      <td>Total CTC (INR):</td>
                      <td className="text-end">--</td>
                      <td className="text-end">
                        {totalAnnualAmount?.toLocaleString("en-IN", {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}
                      </td>
                    </tr>
                  </tbody>
                </Table>
              </div>
              <div className="row">
                {/* Benefits Section */}
                <div className="container-fluid mt-3" id="component_template">
                  <h5 className="text-decoration-underline">
                    ‘NICE’ benefits for you only:
                  </h5>
                  <ul>
                    <li>
                      Enjoy paid leaves as per our leave policy outlined on NEST(in addition to the{" "}
                      <strong>11 days</strong> of the Company’s declared holidays).
                    </li>
                    <li>
                      NICE elevates its Mediclaim Insurance coverage, now offering INR 500,000 for individual employees
                      and INR 500,000 for those opting for floating coverage, which includes spouses and two children.
                      Kindly provide relevant details to HR for updating the policy coverage, if not done already.
                    </li>
                    <li>
                      <strong>Stay Fit & Be Pampered</strong>:{" "}
                      Nice employees are privileged to avail
                      <strong> 60% </strong> discount at <strong>People’s Gym & A Cut
                        Above - Salon & Spa,</strong>Nagpur.
                      Nice employees are privileged to avail discounts in Nagpur, Pune and multiple other locations via its
                      Corporate Membership with gym, salon, cafes, restaurants, path-labs etc. Please visit the latest policy on NEST
                      to understand the procedure to avail the discounts.
                    </li>
                  </ul>
                </div>

                {/* Notes Section */}
                <div className="container-fluid" id="component_template">
                  <h5>
                    <strong>Notes:</strong>
                  </h5>
                  <ul>
                    <li>
                      Your revised remuneration mentioned above shall be effective from{" "}
                      <strong>{fromDate}</strong> and can further be considered for amendments by the management, if required.
                    </li>
                    <li>
                      Variable Payouts mentioned above are your potential earnings, based on your own prior year’s number and
                      due consideration to more opportunities coined for you this year.
                    </li>
                    <li>
                      Refer to the "HR Policies" on NEST for guidelines governing variable components.
                      Please make sure to read the latest HR policy on NEST to understand the eligibility & guidelines for the same.
                    </li>
                    <li>
                      This appraisal shall be deemed as revoked & difference shall be recoverable,
                      should you tender your resignation prior to completion of 6 months from the date of this letter.
                    </li>
                  </ul>
                  <h5 className="mb-0">
                    <strong>DEEP SARAF</strong>
                  </h5>
                  <h5>Managing Director</h5>
                  <div className="fst-italic text-center mt-4">
                    *This is a system generated document and does not require
                    signature and stamp.
                  </div>
                </div>
              </div>
            </div>
          ) : apiStatus === undefined && myComponent.length === 0 ? (
            <div className="d-flex justify-content-center align-items-center flex-column">
              <FaSpinner className="spinner mb-2" />
              <p className="mb-0">Loading</p>
            </div>
          ) : apiStatus === 200 && myComponent.length === 0 ? (
            <div>No Data Found</div>
          ) : null}
        </div>
      </div>
    </>
  );
};

export default MyComponent;
